import { create } from 'zustand';
import type { KlarnaVariant } from '@/hooks/payments/klarna-types';

type KlarnaSelection =
  | { status: 'none' }
  | { status: 'selected'; variant: KlarnaVariant };

interface KlarnaState {
  chooseKlarnaVariant: (args: { variant: KlarnaVariant }) => void;
  clearKlarnaSelection: () => void;
  selection: KlarnaSelection;
}

export const variantOf = (selection: KlarnaSelection) =>
  selection.status !== 'none' ? selection.variant : null;

export const selectVariant = (s: KlarnaState) => variantOf(s.selection);

export const useKlarnaStore = create<KlarnaState>()((set) => ({
  chooseKlarnaVariant: ({ variant }) =>
    set({ selection: { status: 'selected', variant } }),
  clearKlarnaSelection: () => set({ selection: { status: 'none' } }),
  selection: { status: 'none' },
}));
